import { call, put, select } from 'redux-saga/effects';
import { getCurrentUser } from '../../publicSession/selectors';
import { getGrusername } from '../selectors';
import { selectors, withOffset } from '../../Stream';
import { DeviationTypes } from '../../types/deviation';
import { fetch, fakeResponseForType } from './helpers';
import { MEDIA_POPUP_POLL_STREAM_ID, MEDIA_POPUP_STATUS_STREAM_ID, MEDIA_POPUP_JOURNAL_STREAM_ID, MEDIA_POPUP_POSTS_STREAM_ID } from '../constants';
import { normalizeDeviations } from '../../redux/normalizr/helpers';
import { FetchType } from '../../Stream/base/types';
const streamIdToDeviationTypeMap = {
    [MEDIA_POPUP_POLL_STREAM_ID]: DeviationTypes.POLL,
    [MEDIA_POPUP_STATUS_STREAM_ID]: DeviationTypes.STATUS,
    [MEDIA_POPUP_JOURNAL_STREAM_ID]: DeviationTypes.JOURNAL,
    [MEDIA_POPUP_POSTS_STREAM_ID]: 'all_posts'
};
function* handlePostStreamFetch(action) {
    const { streamId } = action;
    const type = streamIdToDeviationTypeMap[streamId];
    const { offset, limit, username, currentUser } = yield select((state)=>({
            currentUser: getCurrentUser(state),
            username: getGrusername(state),
            offset: withOffset.selectors.getNextOffset(state, streamId),
            limit: selectors.getItemsPerFetch(state, streamId)
        }));
    // TODO: update PAPI type once endpoint is created
    const params = {
        type: type === 'all_posts' ? 'all' : type,
        username: username || currentUser.username,
        offset,
        limit
    };
    const fakeResponse = fakeResponseForType(type);
    const response = yield call(fetch, {
        url: 'posts/fetch',
        params,
        fakeResponse
    });
    if (!response) {
        yield put(withOffset.actions.fetchFailure({
            streamId,
            fetchType: FetchType.Next,
            errorMsg: 'Failed to fetch'
        }));
        return;
    }
    const { hasMore, results } = response;
    const normalized = results && normalizeDeviations(results);
    var _normalized_result, _normalized_entities;
    yield put(withOffset.actions.fetchSuccess({
        streamId,
        hasMore: results ? !!hasMore : false,
        items: (_normalized_result = normalized === null || normalized === void 0 ? void 0 : normalized.result) !== null && _normalized_result !== void 0 ? _normalized_result : [],
        entities: (_normalized_entities = normalized === null || normalized === void 0 ? void 0 : normalized.entities) !== null && _normalized_entities !== void 0 ? _normalized_entities : {}
    }));
}
export default handlePostStreamFetch;
